import React from 'react';
import styles from './Loader.module.scss';

/**
 * LoaderSpinner — inline or block spinner.
 *
 * Props:
 *   size   {number|string}  diameter in px, default 18
 *   color  {string}         CSS color, default currentColor (inherits from parent)
 *   block  {boolean}        if true, fills parent container (centered)
 */
export const LoaderSpinner = ({ size = 18, color, block = false }) => {
    const cssVars = {
        '--spinner-size': typeof size === 'number' ? `${size}px` : size,
        ...(color ? { '--spinner-color': color } : {}),
    };

    if (block) {
        return (
            <div className={styles.wrapBlock}>
                <span className={styles.spinner} style={cssVars} aria-label="Hleð..." role="status" />
            </div>
        );
    }

    return (
        <span className={styles.wrap}>
            <span className={styles.spinner} style={cssVars} aria-label="Hleð..." role="status" />
        </span>
    );
};
